import { FC } from 'react';

export const SymptomsIcon: FC = () => {
    return (
        <div className="rounded-4 w-26 h-26 flex items-center justify-center bg-darwin-accent-symptoms-blue-800">
            <div className="w-14 h-12 flex items-center justify-center">
                <svg
                    className="w-14 h-12 fill-white"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                >
                    <path d="M515.6 227.6h-21.55c-50.68 0-76.06-61.28-40.23-97.12l15.25-15.25c11.11-11.11 11.11-29.11 .001-40.22c-11.11-11.11-29.11-11.11-40.22 .001l-15.24 15.24c-35.84 35.84-97.12 10.46-97.12-40.23V28.44c0-15.72-12.72-28.44-28.45-28.44S259.6 12.72 259.6 28.44v21.55c0 50.68-61.28 76.06-97.12 40.23L147.2 74.97C136.1 63.86 118.1 63.86 106.1 74.97c-11.11 11.11-11.11 29.11 .001 40.22l15.25 15.25C158.1 166.3 132.7 227.6 81.99 227.6H60.45C44.72 227.6 32 240.3 32 256s12.72 28.44 28.45 28.44h21.55c50.68 0 76.06 61.28 40.23 97.12l-15.25 15.25c-11.11 11.11-11.11 29.11-.001 40.22c5.555 5.555 12.83 8.333 20.11 8.333c7.277 0 14.55-2.779 20.11-8.334l15.24-15.25c35.84-35.84 97.12-10.46 97.12 40.23v21.55c0 15.72 12.72 28.45 28.45 28.45s28.45-12.72 28.45-28.45v-21.55c0-50.68 61.28-76.06 97.12-40.23l15.24 15.25c5.557 5.555 12.83 8.334 20.11 8.334c7.279 0 14.56-2.778 20.11-8.333c11.11-11.11 11.11-29.11-.001-40.22l-15.25-15.25c-35.84-35.84-10.46-97.12 40.23-97.12h21.55C531.3 284.4 544 271.7 544 256S531.3 227.6 515.6 227.6zM256 272c-26.51 0-48-21.49-48-48s21.49-48 48-48s48 21.49 48 48S282.5 272 256 272zM336 328c-13.25 0-24-10.75-24-24c0-13.26 10.75-23.1 24-23.1s24 10.74 24 24C360 317.3 349.3 328 336 328z"></path>
                </svg>
            </div>
        </div>
    );
};

export const DiagnosisIcon: FC = () => {
    return (
        <div className="rounded-4 w-26 h-26 flex items-center justify-center bg-darwin-accent-diagnosis-purple-800">
            <div className="w-10 h-12 flex items-center justify-center">
                <svg
                    className="w-10 h-12 fill-white"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 384 512"
                >
                    <path d="M224 240C224 231.2 216.8 224 208 224h-32C167.2 224 160 231.2 160 240V288H112C103.2 288 96 295.2 96 303.1V336c0 8.797 7.199 15.1 16 15.1l48 .0006v47.1C160 408.8 167.2 416 176 416h32c8.801 0 16-7.201 16-16v-47.1l48-.0006c8.801 0 16-7.201 16-15.1V303.1C288 295.2 280.8 288 272 288H224V240zM365.3 93.38l-74.63-74.64C278.6 6.742 262.3 0 245.4 0H64C28.65 0 0 28.65 0 64l.0065 384c0 35.34 28.65 64 64 64H320c35.2 0 64-28.8 64-64V138.6C384 121.7 377.3 105.4 365.3 93.38zM336 448c0 8.836-7.164 16-16 16H64.02c-8.838 0-16-7.164-16-16L48 64.13c0-8.836 7.164-16 16-16h160L224 128c0 17.67 14.33 32 32 32h79.1V448z"></path>
                </svg>
            </div>
        </div>
    );
};

export const MedicinesIcon: FC = () => {
    return (
        <div className="rounded-4 w-26 h-26 flex items-center justify-center bg-darwin-accent-medicines-pink-800">
            <div className="w-16 h-12 flex items-center justify-center">
                <svg
                    className="w-16 h-12 fill-white"
                    role="img"
                    viewBox="0 0 16 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M3.76543 5C1.86699 5 0.296678 6.35938 0.0154276 8.14062C0.0154276 8.28125 0.109178 8.375 0.226365 8.375H7.32793C7.44512 8.375 7.53887 8.28125 7.51543 8.16406C7.23418 6.38281 5.6873 5 3.76543 5ZM7.32793 9.125H0.226365C0.109178 9.125 0.0154276 9.24219 0.0388651 9.35938C0.320115 11.1406 1.86699 12.5 3.76543 12.5C5.64043 12.5 7.21074 11.1406 7.49199 9.35938C7.53887 9.24219 7.44512 9.125 7.32793 9.125ZM8.52324 2.04688C8.45293 1.97656 8.3123 1.97656 8.24199 2.07031C7.1873 3.54688 7.30449 5.58594 8.61699 6.92188C9.95293 8.23438 11.992 8.35156 13.4451 7.29688C13.5389 7.22656 13.5389 7.08594 13.4686 7.01562L8.52324 2.04688ZM13.9373 1.60156C12.6014 0.289062 10.5623 0.171875 9.10918 1.22656C9.01543 1.29688 9.01543 1.4375 9.08574 1.50781L14.0311 6.47656C14.1248 6.54688 14.2654 6.54688 14.3357 6.45312C15.367 4.97656 15.2498 2.9375 13.9373 1.60156Z" />
                </svg>
            </div>
        </div>
    );
};

export const InvestigationsIcon: FC = () => {
    return (
        <div className="rounded-4 w-26 h-26 flex items-center justify-center bg-darwin-accent-investigations-ochre-800">
            <div className="w-16 h-12 flex items-center justify-center">
                <svg
                    className="w-16 h-12 fill-white"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                >
                    <path d="M504.1 183l-176-176C324.3 2.344 318.1 0 312 0s-12.28 2.344-16.97 7.031c-9.375 9.375-9.375 24.56 0 33.94l15.16 15.16l-277.3 276.5c-38.75 38.75-45.13 102-9.375 143.5C44.08 500 72.76 512 101.5 512h.4473c26.38 0 52.75-9.1 72.88-30.12l281-280.1l15.19 15.19C475.7 221.7 481.8 224 488 224s12.28-2.344 16.97-7.031C514.3 207.6 514.3 192.4 504.1 183zM333.4 256H177.7l166.3-165.9l77.82 77.73L333.4 256z"></path>
                </svg>
            </div>
        </div>
    );
};

export const DoctorReferralIcon: FC = () => {
    return (
        <div className="rounded-4 w-26 h-26 flex items-center justify-center bg-darwin-neutral-800">
            <div className="w-16 h-16 flex items-center justify-center">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 14 14"
                    className={`w-16 h-16 fill-white`}
                    fill="none"
                >
                    <path
                        d="M7 12.4062C8.87891 12.4062 10.6055 11.416 11.5703 9.76562C12.5098 8.14062 12.5098 6.13477 11.5703 4.48438C10.6055 2.85938 8.87891 1.84375 7 1.84375C5.0957 1.84375 3.36914 2.85938 2.4043 4.48438C1.46484 6.13477 1.46484 8.14062 2.4043 9.76562C3.36914 11.416 5.0957 12.4062 7 12.4062ZM7 0.625C9.31055 0.625 11.4434 1.86914 12.6113 3.875C13.7793 5.90625 13.7793 8.36914 12.6113 10.375C11.4434 12.4062 9.31055 13.625 7 13.625C4.66406 13.625 2.53125 12.4062 1.36328 10.375C0.195312 8.36914 0.195312 5.90625 1.36328 3.875C2.53125 1.86914 4.66406 0.625 7 0.625ZM9.4375 8.59766C9.4375 8.90234 9.1582 9.15625 8.85352 9.15625C8.70117 9.15625 8.54883 9.10547 8.44727 9.00391L7.60938 8.14062L5.9082 9.8418C5.83203 9.91797 5.70508 9.96875 5.57812 9.96875C5.42578 9.96875 5.32422 9.91797 5.22266 9.8418L4.2832 8.90234C4.20703 8.80078 4.15625 8.69922 4.15625 8.54688C4.15625 8.41992 4.20703 8.29297 4.2832 8.2168L5.98438 6.51562L5.12109 5.67773C5.01953 5.57617 4.96875 5.42383 4.96875 5.27148C4.96875 4.9668 5.22266 4.6875 5.52734 4.6875H9.03125C9.23438 4.6875 9.4375 4.89062 9.4375 5.09375V8.59766Z"
                        fill="white"
                    />
                </svg>
            </div>
        </div>
    );
};
